var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-item"},[_c('div',{staticClass:"share__img"},[_c('img',{attrs:{"src":`/img/${_vm.iconName}`,"alt":""}})]),_c('p',{staticClass:"share__text"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }